/**
 * InviteSignupField Component
 * Labeled input wrapper for invite-signup forms (green-bg layout).
 */

export type InviteSignupFieldProps = {
  label: string;
  htmlFor: string;
  children: React.ReactNode;
  helperText?: string;
};

export const InviteSignupField = ({
  label,
  htmlFor,
  children,
  helperText,
}: InviteSignupFieldProps) => (
  <div className="flex flex-col">
    <label
      className="font-termina text-white pb-3 max-md:text-xl uppercase"
      htmlFor={htmlFor}
    >
      {label}
    </label>
    {children}
    {helperText && (
      <p className="font-termina text-white/70 text-sm mt-1">{helperText}</p>
    )}
  </div>
);
